import ReferrersAndGroupsAutocomplete from './ReferrersAndGroupsAutocomplete';

export default ReferrersAndGroupsAutocomplete;
